"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  firstQuestion: _propTypes.default.string,
  subFirstQuestion: _propTypes.default.string,
  secondQuestion: _propTypes.default.string,
  subSecondQuestion: _propTypes.default.string,
  thirdQuestion: _propTypes.default.string,
  subThirdQuestion: _propTypes.default.string,
  fourthQuestion: _propTypes.default.string,
  subFourthQuestion: _propTypes.default.string,
  fifthQuestion: _propTypes.default.string,
  subFifthQuestion: _propTypes.default.string,
  sixthQuestion: _propTypes.default.string,
  subSixthQuestion: _propTypes.default.string,
  seventhQuestion: _propTypes.default.string,
  subSeventhQuestion: _propTypes.default.string,
  eighthQuestion: _propTypes.default.string,
  subEighthQuestion: _propTypes.default.string,
  ninethQuestion: _propTypes.default.string,
  subNinethQuestion: _propTypes.default.string,
  tenthQuestion: _propTypes.default.string,
  subTenthQuestion: _propTypes.default.string,
  eleventhQuestion: _propTypes.default.string,
  subEleventhQuestion: _propTypes.default.string,
  twelfthQuestion: _propTypes.default.string,
  subTwelfthQuestion: _propTypes.default.string
});
exports.default = _default;